export default __webpack_public_path__ + "static/media/collaborator-signature-single.5558eaf8.svg";